// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"510":"23333618","787":"980dee69"}[chunkId] + ".js";
};